import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import {
    MESSAGES,
    isRobIn,
    isPortfolioMajor,
} from '../../../config/admissionRound'

const DetailComment = ({ DataRegister }) => {
    console.log("DataRegister DetailComment: ", DataRegister);
    return (
        <>
            <>

                {
                    (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
                    (
                        <>
                            {
                    isRobIn("commentInterviewNote", DataRegister[0].ROB_ID) ?
                        isPortfolioMajor(DataRegister[0].Major_MAJOR_ID) ?
                            (
                                <Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        {MESSAGES.noteStudyInterviewAnnounce}
                                    </Text>
                                </Pane>
                            )
                            :


                            null

                        :
                        (
                            <>
                                <Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        {MESSAGES.noteStudyInterviewAnnounce}
                                    </Text>
                                    
                                </Pane>
                            </>
                        )
                }
                        </>
                    )
                    :
                    (
                        <>
                        {
                            (DataRegister[0].REGISTER_TYPE_ID === "4" || DataRegister[0].REGISTER_TYPE_ID === "7") ? (<Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        {MESSAGES.noteStudyInterviewAnnounceShort}
                                    </Text>
                                </Pane>)    : null
                        }
                        {
                            (DataRegister[0].REGISTER_TYPE_ID === "2" || DataRegister[0].REGISTER_TYPE_ID === "3") ? (<Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        {MESSAGES.notePrintFormGraduate}
                                    </Text>
                                </Pane>)    : null
                        }
                        </>
                    )
                }

            </>

        </>
    )
}

export default DetailComment
